import { Select } from 'react-daisyui';
import { QBOCompanyData } from '@types';

const { Option } = Select;

interface Props {
  companies: QBOCompanyData[];
  selectedId?: number;
  onSelect: (companyId: number) => void;
}

const countOf = (c: QBOCompanyData) => c.qbo_transactions.length;

/** Dropdown company selector; compact and scales to many companies. */
export function CompanySelectorDropdown({
  companies,
  selectedId,
  onSelect,
}: Props) {
  return (
    <div className='flex items-center' data-testid='company-selector-dropdown'>
      <span className='mr-2'>Company</span>
      <Select
        size='sm'
        value={selectedId}
        onChange={(v: number) => onSelect(Number(v))}
      >
        {companies.map((c) => (
          <Option key={`opt-${c.id as number}`} value={c.id as number}>
            {`${c.name} · ${countOf(c)}`}
          </Option>
        ))}
      </Select>
    </div>
  );
}
